import { CampaignCouponModel } from './CampaignCouponModel';
import { CampaignGatekeeperModel } from './CampaignGatekeeperModel';
import { CampaignNeighborhoodModel } from './CampaignNeighborhoodModel';
import { CampaignTreeModel } from './CampaignTreeModel';
import { CampaignUDF1StepModel } from './CampaignUDF1StepModel';
import { DisplayIfNotAvailableModel } from './DisplayIfNotAvailableModel';

export class CampaignModel {
    campaignId: number;
    displayTreeship = false;
    step2HTMLHeader: string;
    displayIfNotAvailable = false;
    step3HTMLWaiver: string;

    emailHtmlHeader:string;
    emailHtmlFooter:string;

    trees: CampaignTreeModel[];
    ifMyNotAvail: number;
    bi: string;
    
    normalNeighborhoodMulchFee: number;
    targetNeighborhoodMulchFee: number;
    askForMulchFee: boolean;

    coupons: CampaignCouponModel[];
    gatekeepers: CampaignGatekeeperModel[];
    neighborhoods: CampaignNeighborhoodModel[];
    udf1: CampaignUDF1StepModel[];
    udf3: CampaignUDF1StepModel[];
    displayNotAvail: DisplayIfNotAvailableModel[];

    initialsAcceptAbove: string = null;
    initialsReleaseOfLiability: string = null;

    isNew = true;

    public static findNeighborhood(name: string, neighborhoods: CampaignNeighborhoodModel[]): CampaignNeighborhoodModel{
        name = name.toLowerCase();

        for (const neig of neighborhoods) {
            if (neig.neighborhoodName.toLowerCase() === name ||
                (neig.aKANames && neig.aKANames.toLowerCase().includes(name))){
                    return neig;
                }
        }
        return null;
    }
}
